export default "__VITE_ASSET__DDVQgQyz__"